import React, { useState } from "react";
import PageHeaders from "../common/PageHeaders";
import Menu from "../common/Menu";
import Header from "../components/Header";
import Footer from "../components/Footer";
import card from "../images/vertical_black_card_2.webp";

const About = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <>
      <PageHeaders type="about" />
      <div className="flex flex-col h-full" id="outer-container">
        <div className={`relative ${!!menuOpen ? "" : "max-w-page"}`}>
          <Menu
            handleToggle={(state) => {
              setMenuOpen(state.isOpen);
            }}
            hidden={menuOpen}
          />
        </div>
        <div className="topSection bkgDark" id="page-wrap">
          <div className="headerBar">
            <Header siteTitle={"About"} />
          </div>
          <div className="flex mt-32 lg:mt-24">
            <main className="w-full text-dark pt-16">
              <section className="mb-20 px-10 max-w-page py-5">
                <p className="text-xl font-normal  mb-2 text-center uppercase text-primary">
                  About Us
                </p>
                <h1 className="text-3xl md:text-5xl  font-extrabold text-center w-8/12 mx-auto text-white">
                  The smartest card that doesn’t pull your credit.
                </h1>
              </section>
              <section className="w-full bg-white px-10 py-20">
                <div className="md:flex md:items-stretch max-w-page">
                  <div className="md:w-6/12 lg:w-6/12 self-center">
                    <img className="mx-auto px-5 md:w-10/12" src={card} />
                  </div>
                  <div className="md:w-6/12 lg:w-full self-center font-normal text-lg md:px-20">
                    <h2 className="text-3xl font-extrabold mb-5">What we do</h2>
                    <p className="">
                      TomoCredit is built by young immigrant founders who felt
                      the pain of getting a credit card as a foreign national.
                      We are dedicated to building the smartest card that does
                      not require a credit score for approval.
                    </p>
                    <p className="mt-4">
                      Millions of Americans can’t access affordable credit,
                      simply because they have no credit history. Without good
                      credit, everything becomes difficult and more expensive—
                      auto loans, insurance rates, mortgage— even jobs
                      applications are affected by your credit score.
                    </p>
                    <p className="mt-4">
                      We are based in the heart of San Francisco. We are excited
                      to help you get the card that will help you BUILD credit
                      and SAVE money.
                    </p>
                    <p className="mt-4">It’s time for TomoCredit.</p>
                  </div>
                </div>
              </section>
            </main>
          </div>
        </div>
        <Footer />
      </div>
    </>
  );
};

export default About;
